export default {
  'component.seefinnad.title': 'Finn.no',
  'component.seefinnad.description':
    'Her kan du se og godkjenne utkastet til finnannonse. Hvis du har kommentarer, send dem til megleren nedenfor.',
  'component.seefinnad.button': 'Se Finn.no Ad',
  'component.comment-success': 'Kommentar ble lagt til',
  'component.approval.success': 'Godkjenn',
  'component.seefinnad.sendcomment': 'Send kommentar',
};
